var render = function render(){var _vm=this,_c=_vm._self._c;return _c('codemirror',{ref:_vm.ref,attrs:{"options":_vm.settings},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})
}
var staticRenderFns = []

export { render, staticRenderFns }